import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { isEmailChannel } from "../../../channels/types";

import type { FC } from "react";

interface SwitchChannelDialogProps {
  open: boolean;
  channelName: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  willResetContent: boolean;
}

export const SwitchChannelDialog: FC<SwitchChannelDialogProps> = ({
  open,
  channelName,
  onConfirm,
  onCancel,
  willResetContent,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>{`Switch platform to ${channelName}?`}</DialogTitle>
    <DialogContent>
      <Stack direction="column" spacing={2}>
        {willResetContent ? (
          <Alert severity="warning">
            <Typography variant="body2">
              Changing platform to {channelName} will clear all content from your Follow-Up
              {isEmailChannel(channelName)
                ? " as newsletter formatting is not supported for this platform"
                : ""}
              . This action cannot be undone.
            </Typography>
          </Alert>
        ) : (
          <>
            <Typography variant="body2">
              Changing platform to {channelName} will convert your message content and remove
              unsupported formatting, including column layouts, button styling, and some text
              formatting.
            </Typography>
            <Typography variant="body2">This action cannot be undone.</Typography>
          </>
        )}
      </Stack>
    </DialogContent>
    <DialogActions sx={{ justifyContent: "flex-end", px: 3, pb: 2 }}>
      <Button onClick={onConfirm} color="primary" data-analytics-id="follow-up-channel-switch">
        Switch platform{willResetContent && " and lose content"}
      </Button>
      <Button
        onClick={onCancel}
        color="primary"
        data-analytics-id="follow-up-channel-keep-original"
      >
        Keep original platform
      </Button>
    </DialogActions>
  </Dialog>
);
